export const REVIEW_FACTOR = 2.3;

export function daysLeft(deadline: string, today: string): number {
  const ms = new Date(deadline).getTime() - new Date(today).getTime();
  return Math.max(1, Math.round(ms / 86_400_000));
}

export function computeQuota(a: { total: number; learned: number; deadline: string; today: string }) {
  const remaining = Math.max(0, a.total - a.learned);
  const dl = daysLeft(a.deadline, a.today);
  const overdue = new Date(a.deadline).getTime() < new Date(a.today).getTime();
  const newPerDay = Math.max(5, Math.ceil(remaining / dl));
  return {
    daysLeft: dl,
    overdue,
    remaining,
    newPerDay,
    dailyTotal: Math.ceil(newPerDay * REVIEW_FACTOR),
  };
}
